export default "__VITE_ASSET__MfB8a5Ye__"